import { queryClient, apiRequest } from "../lib/queryClient";

const cmsKey = "cms";

export function usePages(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchPages = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/cms?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const fetchPageById = async (pageId) => {
    const response = await apiRequest(`/admin/cms/${pageId}`, {
      method: "GET",
    });
    return response;
  };

  const createPage = async (pageData) => {
    const response = await apiRequest("/admin/cms", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return response;
  };

  const updatePage = async (id, pageData) => {
    const response = await apiRequest(`/admin/cms/${id}`, {
      method: "PUT",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return response;
  };

  const deletePage = async (pageId) => {
    await apiRequest(`/admin/cms/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return pageId;
  };

  return {
    fetchPages,
    createPage,
    updatePage,
    deletePage,
    fetchPageById
  };
}
